import React, { useEffect, useMemo, useState } from 'react';
import { RiImageLine } from 'react-icons/ri';
import { getProductImageUrl, getProductInitials } from '../../utils/productImage';

export default function ProductCardImage({ product, productName, alt, className = 'product-img' }) {
    const imageUrl = useMemo(() => getProductImageUrl(product), [product]);
    const [failedUrl, setFailedUrl] = useState(null);

    useEffect(() => {
        setFailedUrl(null);
    }, [imageUrl]);

    const showImage = Boolean(imageUrl) && failedUrl !== imageUrl;

    if (!showImage) {
        const initials = getProductInitials(productName);

        return (
            <div
                className="product-img-placeholder"
                role="img"
                aria-label={alt || productName || 'Menu item image unavailable'}
            >
                <span className="product-img-placeholder__initials">{initials}</span>
                <RiImageLine className="product-img-placeholder__icon" aria-hidden />
            </div>
        );
    }

    return (
        <img
            src={imageUrl}
            className={className}
            alt={alt || productName || 'Menu item'}
            loading="lazy"
            decoding="async"
            onError={() => setFailedUrl(imageUrl)}
        />
    );
}
